import { h6 } from '../typography';
import theme from '../default';

export default {
    root: {
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
            '&.Mui-expanded': {
                marginLeft: theme.spacing(1),
            },
        },
        '& .MuiTypography-root': {
            ...h6,
        },
    },
};
